import { useEffect } from 'react';
import { feedUrl } from '@/api/config';
import { queryClient } from '@/api/query-client';
import { queryKeys } from '@/api/query-keys';
import { useOptionalLiveFeed } from '@/live/LiveFeedProvider';

function feedHubUrl(): string | null {
  if (!feedUrl.trim()) return null;
  return `${feedUrl.replace(/\/+$/, '')}/signalr/`;
}

function invalidateLiveListQueries(): void {
  void queryClient.invalidateQueries({ queryKey: [...queryKeys.live.all, 'tables'] });
  void queryClient.invalidateQueries({ queryKey: [...queryKeys.live.all, 'sports'] });
  void queryClient.invalidateQueries({ queryKey: [...queryKeys.live.all, 'tournaments'] });
}

/** Subscribes to the legacy live odds feed and patches event statistics and odds. */
export function useLiveFeedSocket(enabled = true) {
  const liveFeed = useOptionalLiveFeed();

  useEffect(() => {
    if (!enabled || !liveFeed) return;

    const hubUrl = feedHubUrl();
    if (!hubUrl) return;

    let disconnect: (() => void) | undefined;
    let cancelled = false;

    void import('./live-feed-connection').then(({ connectLiveFeed }) => {
      if (cancelled) return;
      disconnect = connectLiveFeed(hubUrl, {
        onStatisticsPatch: liveFeed.patchEventStatistics,
        onOddsPatch: liveFeed.patchEventOdds,
        onEventFinished: (eventId) => {
          liveFeed.markEventFinished(eventId);
          invalidateLiveListQueries();
        },
      });
    });

    return () => {
      cancelled = true;
      disconnect?.();
    };
  }, [enabled, liveFeed]);
}
